module.exports = __webpack_public_path__ + "static/media/organizacion.b5dd5019.svg";